import { formatDateOnly } from '@/lib/date-utils';
import type { BoardAssignment } from '@/hooks/use-staffing-board';

/**
 * Text for the "Remove from job?" dialog. Removing a board card keeps the
 * person's crew assignment, so only promise that when one actually exists.
 */
export function removeConfirmMessage(
  techName: string,
  projectName: string,
  assignment?: Pick<BoardAssignment, 'assignment_id' | 'start_date' | 'end_date'>,
): string {
  if (assignment?.assignment_id != null) {
    const start = formatDateOnly(assignment.start_date, assignment.start_date, { day: 'numeric', month: 'short' });
    const end = assignment.end_date
      ? `–${formatDateOnly(assignment.end_date, assignment.end_date, { day: 'numeric', month: 'short' })}`
      : '';
    return `${techName} still has ${start}${end} on this job — that assignment is kept.`;
  }
  return `${techName} will be fully removed from ${projectName}. They have no crew assignment on this job to keep. Their other jobs are not affected.`;
}
